// Do not let us merge a property onto target that does not already exist on the target.
export function typedAssign<T extends object>(target: T, source: Partial<T>): T {
  // This type assertion is safe because we've constrained U to be a subset of T
  return Object.assign(target, source) as T;
}
